var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldenLightActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 64.5,
    y1: 14,
    x2: 87.8,
    y2: 13.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 64.6,
    y1: 24.4,
    x2: 85.6,
    y2: 24.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 66.2,
    y1: 33.5,
    x2: 83.5,
    y2: 33.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 65.4,
    y1: 38.6,
    x2: 82.9,
    y2: 38.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: -14.2,
    y1: -58.3,
    x2: 7,
    y2: -73.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: -9.2,
    y1: -58.8,
    x2: 7.3,
    y2: -71,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 31.2,
    y1: 0.6,
    x2: 42.7,
    y2: -7.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 43.7,
    y1: 18,
    x2: 54.1,
    y2: 10.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 78.9,
    y1: 26.1,
    x2: 115.4,
    y2: 52.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 75.6,
    y1: 35.3,
    x2: 105.9,
    y2: 57.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 76.2,
    y1: 44.6,
    x2: 96.4,
    y2: 59.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 73.1,
    y1: 48.6,
    x2: 92.3,
    y2: 62.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 97.1,
    y1: 56.1,
    x2: 103.5,
    y2: 76.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 90.1,
    y1: 57.4,
    x2: 96.1,
    y2: 76.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 87.6,
    y1: 59.6,
    x2: 92.7,
    y2: 75.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 83.6,
    y1: 59.9,
    x2: 88.8,
    y2: 76.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 119.4,
    y1: 74.2,
    x2: 104.9,
    y2: 114.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 110.9,
    y1: 73.4,
    x2: 98.6,
    y2: 108.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 105,
    y1: 76.5,
    x2: 96.1,
    y2: 101.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 102.5,
    y1: 75.2,
    x2: 93.9,
    y2: 99.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 119,
    y1: 190.7,
    x2: 103.5,
    y2: 201.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 129,
    y1: 176.4,
    x2: 111.4,
    y2: 188.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 93.5,
    y1: 123.3,
    x2: 81,
    y2: 131.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 82.4,
    y1: 108.1,
    x2: 71.3,
    y2: 115.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 62.6,
    y1: 114.7,
    x2: 36.1,
    y2: 113.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 62.8,
    y1: 104.1,
    x2: 39,
    y2: 103.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 61.1,
    y1: 94.6,
    x2: 42.1,
    y2: 93.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 62.1,
    y1: 89.5,
    x2: 43,
    y2: 88.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 48.2,
    y1: 102.3,
    x2: 12,
    y2: 75.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 51.5,
    y1: 93.1,
    x2: 21.5,
    y2: 71,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 51,
    y1: 83.9,
    x2: 30.9,
    y2: 69.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 54,
    y1: 79.9,
    x2: 35,
    y2: 65.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x1: 30.5,
    y1: 72.6,
    x2: 24.3,
    y2: 52.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 37.6,
    y1: 71.3,
    x2: 31.6,
    y2: 52,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x1: 40.1,
    y1: 69.2,
    x2: 35.1,
    y2: 52.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 44.1,
    y1: 68.9,
    x2: 39,
    y2: 52.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x1: 8.7,
    y1: 54.7,
    x2: 23,
    y2: 14.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 17.1,
    y1: 55.5,
    x2: 29.3,
    y2: 20.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 23,
    y1: 52.5,
    x2: 31.8,
    y2: 27.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: 25.5,
    y1: 53.7,
    x2: 34,
    y2: 29.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fefefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g41",
    cx: 63.1,
    cy: 61.6,
    r: 7.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g42",
    cx: 62.8,
    cy: 66.5,
    r: 11.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a1e"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f0a34}.b{fill:#1f0a34;stroke:#010204;stroke-width:.4}.c{fill:url(#g1)}.d{fill:url(#g2)}.e{fill:url(#g3)}.f{fill:url(#g4)}.g{fill:url(#g5)}.h{fill:url(#g6)}.i{fill:url(#g7)}.j{fill:url(#g8)}.k{fill:url(#g9)}.l{fill:url(#g10)}.m{fill:url(#g11)}.n{fill:url(#g12)}.o{fill:url(#g13)}.p{fill:url(#g14)}.q{fill:url(#g15)}.r{fill:url(#g16)}.s{fill:url(#g17)}.t{fill:url(#g18)}.u{fill:url(#g19)}.v{fill:url(#g20)}.w{fill:url(#g21)}.x{fill:url(#g22)}.y{fill:url(#g23)}.z{fill:url(#g24)}.A{fill:url(#g25)}.B{fill:url(#g26)}.C{fill:url(#g27)}.D{fill:url(#g28)}.E{fill:url(#g29)}.F{fill:url(#g30)}.G{fill:url(#g31)}.H{fill:url(#g32)}.I{fill:url(#g33)}.J{fill:url(#g34)}.K{fill:url(#g35)}.L{fill:url(#g36)}.M{fill:url(#g37)}.N{fill:url(#g38)}.O{fill:url(#g39)}.P{fill:url(#g40)}.Q{fill:url(#g41)}.R{fill:url(#g42)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m127.4 64.2c0 35.1-28.4 63.6-63.5 63.6-35.1 0-63.6-28.5-63.6-63.6 0-35.1 28.5-63.5 63.6-63.5 35.1 0 63.5 28.4 63.5 63.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m87.8 14.2c0 0-2.3 8.6-7.2 14.2-5.2 6.1-9.3 11.4-9.3 11.4 0 0-6.5 8.4-6.5 14.4 0 0 1.6-7.4 6.1-11.8 5.9-5.8 16.1-17 16.9-28.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m75.8 41.5c-3.2 2.8-5.7 5.7-6.2 6.3-3.1 3.6-4.8 9.4-4.8 9.4 0-4.5 4.6-11.2 4.6-11.2 0 0 2.5-3.7 7.1-7.9 6.2-5.7 9.1-13.6 9.1-13.6-0.6 5.2-5.4 13-9.8 17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m72.8 47.6c-6 4.7-6.5 6.8-6.5 6.8 0.7-3.4 5.4-8.5 10.4-12.5 5-4 6.8-8.4 6.8-8.4-0.5 2.8-4.7 9.4-10.7 14.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m76.8 48.1c-0.8 0.8-2.2 1.7-3.2 2.2-6.9 3.5-8.1 7.7-8.1 7.7 0 0 2.1-6.7 9.6-10.6 6.8-3.6 7.8-8.8 7.8-8.8-0.4 2.6-3.8 7.2-6.1 9.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m53.6 9.8c0 0 3.2 8.3 2.6 15.7-0.7 8-0.8 14.7-0.8 14.7 0 0-0.3 10.6 3.1 15.5 0 0-3-6.9-2-13.2 1.4-8.2 3.1-23.2-2.9-32.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m59.9 38.9c-0.9 4.2-1.2 7.9-1.2 8.8-0.4 4.7 1.6 10.4 1.6 10.4-2.6-3.6-2.8-11.8-2.8-11.8 0 0-0.2-4.5 1-10.5 1.7-8.4-0.6-16.4-0.6-16.4 2.6 4.5 3.3 13.7 2 19.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m61.1 45.6c-2.1 7.3-1.2 9.3-1.2 9.3-1.4-3.1-0.6-10 1.1-16.2 1.7-6.2 0.6-10.8 0.6-10.8 1.2 2.6 1.6 10.4-0.5 17.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m64.7 43.7c-0.2 1.1-0.8 2.6-1.3 3.6-3.5 6.9-2.1 11.1-2.1 11.1 0 0-2.2-6.7 1.5-14.3 3.4-6.9 1.3-11.7 1.3-11.7 1.1 2.4 1.1 8 0.6 11.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m112.5 38.1c0 0-7 5.6-14.3 7.2-7.7 1.8-14.2 3.7-14.2 3.7 0 0-10.2 2.9-13.8 7.7 0 0 5.7-5 11.9-5.9 8.3-1.1 23.1-4.1 30.4-12.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m86.6 53c-4.3 0.3-7.9 1.2-8.8 1.4-4.5 1-9.4 4.7-9.4 4.7 2.7-3.6 10.4-6.3 10.4-6.3 0 0 4.2-1.5 10.4-2.1 8.4-0.9 15.4-5.5 15.4-5.5-3.6 3.7-12 7.2-18 7.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m80.6 56.1c-7.6 0.2-9.3 1.6-9.3 1.6 2.6-2.3 9.4-3.6 15.8-3.8 6.4-0.3 10.5-2.7 10.5-2.7-2.1 1.9-9.4 4.7-17 4.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m83.5 58.9c-1.1 0.2-2.7 0-3.9-0.1-7.6-1.3-11.1 1.4-11.1 1.4 0 0 5.7-4.1 14-2.9 7.7 1.1 11.6-2.4 11.6-2.4-2 1.9-7.4 3.5-10.6 4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m118.6 72.3c0 0-8.9 0.3-15.7-2.7-7.3-3.2-13.7-5.5-13.7-5.5 0 0-9.9-3.7-15.6-2 0 0 7.5-0.6 13.1 2.4 7.3 3.9 21 10.4 31.9 7.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m89 68.9c-3.7-2.3-7.1-3.7-7.9-4.1-4.3-1.9-10.4-1.8-10.4-1.8 4.3-1.3 12.1 1.1 12.1 1.1 0 0 4.3 1.3 9.6 4.5 7.3 4.2 15.7 4.7 15.7 4.7-5.1 0.9-14-1.3-19.1-4.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m82.3 67.8c-6.3-4.3-8.4-4.2-8.4-4.2 3.4-0.3 9.6 2.7 15 6.3 5.3 3.6 10 4.1 10 4.1-2.8 0.3-10.4-1.8-16.6-6.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m82.9 71.8c-1-0.5-2.2-1.6-3-2.4-5.4-5.5-9.8-5.5-9.8-5.5 0 0 7.1 0.1 13 6 5.5 5.5 10.7 5 10.7 5-2.6 0.3-8-1.6-10.9-3.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m102.9 103.7c0 0-7.2-5.1-10.9-11.6-3.9-7-7.6-12.7-7.6-12.7 0 0-5.7-8.9-11.3-11 0 0 6.4 4 9 9.8 3.5 7.5 10.6 21 20.8 25.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m81.4 83.1c-1.6-4-3.5-7.3-3.9-8-2.3-4.1-7.2-7.7-7.2-7.7 4.2 1.5 8.9 8.1 8.9 8.1 0 0 2.7 3.7 5.1 9.4 3.2 7.8 9.6 13.2 9.6 13.2-4.6-2.3-10.3-9.5-12.5-15z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m76.6 78.2c-2.4-7.3-4.1-8.4-4.1-8.4 2.9 1.8 6.1 7.9 8.1 14 2.1 6.1 5.6 9.3 5.6 9.3-2.5-1.4-7.2-7.7-9.6-14.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m74.7 81.8c-0.4-1-0.7-2.6-0.9-3.8-1-7.6-4.5-10.2-4.5-10.2 0 0 5.6 4.2 6.7 12.6 1.1 7.6 5.6 10.4 5.6 10.4-2.3-1.3-5.4-6.1-6.9-9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m72 118.7c0 0-2.8-8.4-1.9-15.8 1-7.9 1.4-14.7 1.4-14.7 0 0 0.7-10.5-2.5-15.6 0 0 2.7 7.1 1.4 13.3-1.7 8.1-4 23.1 1.6 32.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m66.9 89.4c1.1-4.2 1.5-7.9 1.6-8.8 0.6-4.6-1.2-10.4-1.2-10.4 2.4 3.7 2.3 11.8 2.3 11.8 0 0 0 4.5-1.5 10.5-2 8.3-0.1 16.4-0.1 16.4-2.3-4.6-2.7-13.8-1.1-19.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m65.9 82.6c2.4-7.2 1.7-9.2 1.7-9.2 1.3 3.2 0.2 10-1.8 16.1-1.9 6.1-1 10.8-1 10.8-1.1-2.6-1.3-10.4 1.1-17.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m62.3 84.4c0.2-1.1 0.9-2.6 1.5-3.6 3.7-6.7 2.5-10.9 2.5-10.9 0 0 1.9 6.7-2.1 14.1-3.7 6.8-1.7 11.7-1.7 11.7-1.1-2.4-0.8-8.1-0.2-11.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m37.8 112.9c0 0 2.7-8.5 7.8-13.9 5.5-5.8 9.9-11 9.9-11 0 0 6.9-8 7.2-14 0 0-2 7.3-6.7 11.5-6.2 5.5-17 16.2-18.2 27.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m51.1 86.2c3.3-2.7 5.9-5.4 6.5-6.1 3.2-3.4 5.2-9.1 5.2-9.1-0.2 4.5-5.1 10.9-5.1 10.9 0 0-2.7 3.7-7.5 7.6-6.5 5.4-9.8 13.1-9.8 13.1 0.9-5.1 6-12.7 10.7-16.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m54.4 80.2c6.2-4.4 6.8-6.4 6.8-6.4-0.9 3.3-5.8 8.1-11 11.9-5.2 3.8-7.2 8-7.2 8 0.6-2.7 5.1-9.1 11.4-13.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m50.4 79.5c0.8-0.8 2.2-1.5 3.3-2 7-3.2 8.5-7.4 8.5-7.4 0 0-2.5 6.6-10.1 10.2-7 3.3-8.3 8.4-8.3 8.4 0.6-2.6 4.2-7 6.6-9.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m14.6 90.2c0 0 7-5.5 14.3-7.1 7.8-1.7 14.3-3.5 14.3-3.5 0 0 10.2-2.9 13.8-7.7 0 0-5.7 5-12 5.8-8.2 1.1-23.1 4-30.4 12.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m40.6 75.6c4.2-0.4 7.9-1.2 8.8-1.4 4.5-1 9.4-4.6 9.4-4.6-2.7 3.5-10.4 6.1-10.4 6.1 0 0-4.2 1.5-10.4 2.1-8.5 0.9-15.5 5.4-15.5 5.4 3.6-3.7 12.1-7.1 18.1-7.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m46.6 72.4c7.6-0.1 9.3-1.5 9.3-1.5-2.6 2.3-9.4 3.5-15.8 3.7-6.5 0.2-10.5 2.7-10.5 2.7 2.1-1.9 9.4-4.7 17-4.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m43.7 69.6c1.1-0.2 2.8 0 3.9 0.2 7.6 1.3 11.1-1.3 11.1-1.3 0 0-5.7 4-14 2.8-7.7-1.2-11.6 2.2-11.6 2.2 2-1.8 7.4-3.4 10.6-3.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m9.2 56.2c0 0 8.9-0.2 15.7 2.8 7.3 3.2 13.6 5.6 13.6 5.6 0 0 9.9 3.8 15.7 2.1 0 0-7.6 0.6-13.1-2.4-7.3-4-21-10.6-31.9-8.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m38.8 59.9c3.6 2.2 7.1 3.7 7.9 4.1 4.2 1.9 10.3 1.9 10.3 1.9-4.3 1.2-12-1.3-12-1.3 0 0-4.3-1.3-9.6-4.4-7.3-4.4-15.7-4.9-15.7-4.9 5.1-0.9 14 1.4 19.1 4.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m45.5 60.9c6.2 4.4 8.4 4.3 8.4 4.3-3.5 0.3-9.7-2.7-15-6.4-5.3-3.6-9.9-4.1-9.9-4.1 2.7-0.3 10.3 1.8 16.5 6.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m44.8 56.9c1 0.6 2.2 1.7 3 2.5 5.4 5.5 9.8 5.5 9.8 5.5 0 0-7-0.1-13-6.1-5.4-5.5-10.6-5-10.6-5 2.6-0.3 8 1.6 10.8 3.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m24.7 25.2c0 0 7.3 5.1 11 11.6 4 6.9 7.6 12.6 7.6 12.6 0 0 5.8 8.9 11.4 11 0 0-6.4-4-9.1-9.8-3.5-7.5-10.6-20.9-20.9-25.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m46.4 45.7c1.6 4 3.5 7.2 3.9 8 2.3 4.1 7.2 7.6 7.2 7.6-4.2-1.5-9-8.1-9-8.1 0 0-2.6-3.6-5-9.3-3.3-7.8-9.8-13.2-9.8-13.2 4.7 2.3 10.5 9.5 12.7 15z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m51.2 50.6c2.4 7.2 4.2 8.4 4.2 8.4-3-1.9-6.2-8-8.3-14.1-2.1-6-5.6-9.2-5.6-9.2 2.5 1.4 7.3 7.6 9.7 14.9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m53 47c0.5 1 0.8 2.6 1 3.7 1 7.7 4.5 10.3 4.5 10.3 0 0-5.6-4.3-6.8-12.6-1.1-7.7-5.6-10.4-5.6-10.4 2.3 1.3 5.5 6 6.9 9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m67.3 55.2c3.6 2.3 4.6 7 2.3 10.6-2.3 3.5-7.1 4.6-10.6 2.2-3.6-2.3-4.6-7-2.3-10.6 2.3-3.5 7.1-4.5 10.6-2.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "R",
    d: "m70.8 57.4c3.7 3.6 4.4 9.5 1.5 14-3.4 5.2-10.4 6.7-15.6 3.3-5.2-3.4-6.7-10.3-3.3-15.5q1.1-1.7 2.5-2.8-0.2 0.2-0.3 0.5c-2.7 4.1-1.5 9.6 2.6 12.3 4.1 2.7 9.7 1.5 12.3-2.7 1.9-2.8 1.9-6.4 0.3-9.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenLightActive);
export default __webpack_public_path__ + "static/media/golden-light-active.4ee68823eb154174726a847af71ca204.svg";
export { ForwardRef as ReactComponent };